import { render, staticRenderFns } from "./GenericAlert.vue?vue&type=template&id=14508ba5&"
import script from "./GenericAlert.vue?vue&type=script&lang=js&"
export * from "./GenericAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports